/**
 *
 * @param {MainClassProps} main
 * @param {EventListProps} event
 * @param {ListenerDetailsProps} details
 * @param {TriggerProps} trigger
 * @param {Array<TorusElement>} targets
 */
const addLocalListener = (main, event, details, trigger, targets) => {
  for (const target of targets) {
    /** Check if already registered */
    let found = false;

    for (const entry of main.listeners) {
      if (
        entry.event === event &&
        entry.target === target &&
        entry.trigger === trigger
      ) {
        found = true;
        break;
      }
    }

    /** Skip duplicate */
    if (found) continue;

    /**
     * Custom listener callback function
     * @param {CustomEventProps} e
     */
    const callback = (e) => {
      e.details = details;

      return main.on.get(event)?.(e);
    };

    target.addEventListener(event, callback);

    main.listeners.add({ event, target, callback, trigger });
    main.events.set(`${event}:${trigger.get("name")}`, { details });
  }
};

export default addLocalListener;
